import { supabase } from "@/integrations/supabase/client";

export interface CalculationResult {
  monthlySavings: number;
  yearlySavings: number;
  newRepayment: number;
  reductionPercentage: number;
  urgentSubmission: boolean;
}

export interface FormData {
  name: string;
  email: string;
  salary: string;
  obligations: string;
}

const STANDARD_REDUCTION = 0.60; // 60%
const URGENT_BONUS = 0.05; // Additional 5%

export const calculateSavingsResult = (obligations: number, isUrgent: boolean = false): CalculationResult => {
  const reductionRate = isUrgent ? STANDARD_REDUCTION + URGENT_BONUS : STANDARD_REDUCTION;
  const newRepayment = obligations * (1 - reductionRate);
  const monthlySavings = obligations - newRepayment;
  const yearlySavings = monthlySavings * 12;
  const reductionPercentage = (monthlySavings / obligations) * 100;

  return {
    monthlySavings,
    yearlySavings,
    newRepayment,
    reductionPercentage,
    urgentSubmission: isUrgent
  };
};

export const saveCalculationResults = async (formData: FormData, calculationData: CalculationResult, userId: string) => {
  try {
    const { data, error } = await supabase
      .from('calculations')
      .insert({
        user_id: userId,
        name: formData.name,
        email: formData.email,
        salary: parseFloat(formData.salary),
        obligations: parseFloat(formData.obligations),
        monthly_savings: calculationData.monthlySavings,
        yearly_savings: calculationData.yearlySavings,
        new_repayment: calculationData.newRepayment,
        reduction_percentage: calculationData.reductionPercentage,
        urgent_submission: calculationData.urgentSubmission
      })
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error saving calculation:', error);
    throw error;
  }
};